<template>
	<div class="user-affiliate fin-w-full">
        <div class="section-table">
            <el-divider content-position="left">{{isReferrer ? `Referrer` : `User` }} affiliate link management</el-divider>
            <pagination
                    class="pagination-bottom"
                    :total="links.total"
                    :page.sync="links.current_page"
                    :limit.sync="links.per_page"
                    @pagination="getAffiliateDetails(false)"
                    @sizeChange="getAffiliateDetails(true)"
                    :separate-change="true"
                    :page-sizes="[5, 10, 15, 20, 25]"
                >
                    <el-input
                        class="w-100"
                        clearable
                        style="margin-left: 10px"
                        size="small"
                        v-model="search"
                        placeholder="Search Links"
                    ></el-input>
                    <el-button style="margin-left: 10px" size="small" type="default" @click="getAffiliateDetails()" icon="el-icon-search"></el-button>
                    <el-button style="margin-left: 10px" size="small" type="success" @click="saveAffiliateDetails()" :disabled="this.hasForms">Create Link</el-button>
            </pagination>
			<el-table
				ref="linksTable"
				v-loading="tableLoading"
				:data="tableData"
				stripe
				border
				style="width: 100%"
			    >
				<el-table-column sortable label="Link">
					<template slot-scope="scope">
						<a :href="_.toLower(_.get(scope, 'row.link.default_short_url'))" :target="'_blank'">{{ _.toLower(_.get(scope, 'row.link.default_short_url')) }}</a>
					</template>
				</el-table-column>
                
                <el-table-column width="250" sortable label="Form">
                    <template slot-scope="affiliateScope">
                        <el-select v-model="affiliateScope.row.form_id" filterable placeholder="Select Form" @change="assignToAffiliate($event, affiliateScope.row, 'form')">
                            <el-option
                            v-for="form in forms"
                            :key="form.id"
                            :label="form.name"
                            :value="`${form.id}`">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>

                <el-table-column width="100" align="center" sortable label="Visits">
					<template slot-scope="scope">
						<span>{{ _.size(_.get(scope,'row.link.visits', [])) }}</span>
					</template>
				</el-table-column>



                <el-table-column v-if="Ambition.hasRoleOrPermission(['referrer'])" width="400" header-align="center" label="Embed Code">
					<template slot-scope="scope">
						<code>{{ _.get(scope,'row.embed_code') }}</code>
					</template>
				</el-table-column>
                <el-table-column width="200" align="center" label="QR Code">
					<template slot-scope="scope">
                        <div style="max-width:50px; margin: 0 auto;"><qr-code :size="150" :text="_.get(scope, 'row.link.default_short_url')"></qr-code></div>
					</template>
				</el-table-column>
                <!-- <el-table-column width="200" align="center" label="">
					<template slot-scope="scope">
                        <el-button size="small" type="success" @click="addLinktoWallet(_.get(scope, 'row'))">Add to wallet</el-button>
					</template>
				</el-table-column> -->
			</el-table>
            <pagination
                    class="pagination-bottom"
                    :total="links.total"
                    :page.sync="links.current_page"
                    :limit.sync="links.per_page"
                    @pagination="getAffiliateDetails(false)"
                    @sizeChange="getAffiliateDetails(true)"
                    :separate-change="true"
                    :page-sizes="[5, 10, 15, 20, 25]"
                >
                    <el-input
                        class="w-100"
                        clearable
                        style="margin-left: 10px"
                        size="small"
                        v-model="search"
                        placeholder="Search Links"
                    ></el-input>
                    <el-button style="margin-left: 10px" size="small" type="default" @click="getAffiliateDetails()" icon="el-icon-search"></el-button>
                    <el-button style="margin-left: 10px" size="small" type="success" @click="saveAffiliateDetails()">Create Link</el-button>
            </pagination>
		</div>
	</div>
</template>

<script>
    import Pagination from "@shared/components/pagination"
    import VueQRCodeComponent from 'vue-qrcode-component'
	export default {
		name: "UserAffiliateSettings",
        components: {
            'qr-code':VueQRCodeComponent,
            Pagination
        },
		data() {
			return {
                links: [],
                search: '',
                tableLoading: false,
                forms: [],
                hasForms: true,
			}
		},

        computed: {
            user() {
                return this.$store.getters['user/user']
            },
            tableData() {
				if (_.isEmpty(this.links.data)) return
				return this.links.data
			},
            isReferrer() {
                return Ambition.hasRoleOrPermission(['referrer'])
            },
            teamId() {
                return _.get(Ambition, 'Globals.tenant.user.current_team_id')
            }
        },

		mounted() {
            this.getAffiliateDetails();
            this.getForms();
        },

		methods: {
            getForms() {
                this.$tenant
                    .post(`/api/forms/list`)
                    .then((res) => {
                        this.forms = res.data
                        if (this.forms.length > 0){
                            this.hasForms = false
                        }
                    })
                    .catch((err) => {
                        console.error(err)
                    })
            },
            assignToAffiliate(value, form, type) {
                let data;

                if (type == 'form'){
                    data = {
                        form_id: value
                    };
                } else {
                    data = {
                        team_id: value
                    };
                }


                this.$tenant
                    .post(`/api/forms/assign-link/${form.id}`, data)
                    .then((res) => {
                    })
                    .catch((err) => {
                        console.error(err)
                    })
            },
            getAffiliateDetails(resetPage) {
				this.tableLoading = true

				if (resetPage) {
					this.links.current_page = 1
				}

				let data = {
					paginated: true,
					page: this.links.current_page,
					per_page: this.links.per_page,
					search: this.search,
                    referrer: this.isReferrer
				}

				this.$tenant
					.post(`/admin/account/get-affiliate-link`, data)
					.then((res) => {
						this.links = res.data
						this.tableLoading = false
					})
					.catch((err) => {
						err.output()
					})
			},
            saveAffiliateDetails() {
                this.tableLoading = true
                this.$tenant.post('/admin/account/create-affiliate-link', {
                    referrer: this.isReferrer,
                    team_id: this.teamId
                })
                .then(response => {
                    this.getAffiliateDetails();
                })
                .catch(err => {
                    console.warn('err',err)
                })
            },
            addLinktoWallet(link) {
                this.$tenant.post('/admin/account/create-wallet-pass', {
                    referrer: this.isReferrer,
                    team_id: this.teamId,
                    link: link
                },{
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'pass.pkpass');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(err => {
                    console.warn('err',err)
                })
            }
        },
	}
</script>

<style lang="scss" scoped>
	.user-affiliate {
        padding: 50px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
	}
</style>
